export default __webpack_public_path__ + "static/range-motion-zeta-221c8e00deb2af90bd665565099a0d14.gif";